import * as z from "zod";
import { trackerStatusSchema } from "./order-tracking-tracker-status-definition";
import { trackingLocationSchema } from "./order-tracking-tracking-location-definition";

const trackingEventInputSchema_ = z.object({
  timestamp: z.coerce.date(),
  status: trackerStatusSchema,
  statusDetail: z.string().nullish(),
  message: z.string(),
  location: trackingLocationSchema.nullish(),
});
export const trackingEventInputSchema: z.ZodType<TrackingEventInput> =
  trackingEventInputSchema_;
export interface TrackingEventInput extends z.infer<
  typeof trackingEventInputSchema_
> {}

const trackingEventSchema_ = z.object({
  id: z.coerce.bigint(),
  orderTrackingShipmentId: z.coerce.bigint(),
  accountId: z.coerce.bigint(),
  timestamp: z.coerce.date(),
  status: trackerStatusSchema,
  statusDetail: z.string().nullish(),
  message: z.string(),
  locationRaw: z.string().nullish(),
  locationCity: z.string().nullish(),
  locationState: z.string().nullish(),
  locationCountry: z.string().nullish(),
  locationPostalCode: z.string().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export const trackingEventSchema: z.ZodType<TrackingEvent> =
  trackingEventSchema_;
export interface TrackingEvent extends z.infer<typeof trackingEventSchema_> {}

const trackingEventWithoutIdsSchema_ = z.object({
  timestamp: z.coerce.date(),
  status: trackerStatusSchema,
  statusDetail: z.string().nullish(),
  message: z.string(),
  locationRaw: z.string().nullish(),
  locationCity: z.string().nullish(),
  locationState: z.string().nullish(),
  locationCountry: z.string().nullish(),
  locationPostalCode: z.string().nullish(),
});
export const trackingEventWithoutIdsSchema: z.ZodType<TrackingEventWithoutIds> =
  trackingEventWithoutIdsSchema_;
export interface TrackingEventWithoutIds extends z.infer<
  typeof trackingEventWithoutIdsSchema_
> {}

export interface InsertTrackingEventInput {
  orderTrackingShipmentId: bigint;
  accountId: bigint;
  timestamp: Date;
  status: string;
  statusDetail?: string | null;
  message: string;
  locationRaw?: string | null;
  locationCity?: string | null;
  locationState?: string | null;
  locationCountry?: string | null;
  locationPostalCode?: string | null;
}
